<ng-container *ngIf="isMobile; else desktopComponent">
  <app-swipe-up
    [height]="95"
    [showHeader]="true"
    [showFooter]="true"
    [showSwipeUp]="true"
    (toggleShowSwipeUp)="closeWebview()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="cardPrimeTemplate"></ng-container>
    </ng-container>
    <ng-container footer>
      <ng-container *ngTemplateOutlet="cardPrimeFooter"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopComponent>
    <app-modal
      [width]="447"
      [showHeader]="true"
      (toggleModal)="closeWebview()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="cardPrimeTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="cardPrimeFooter"></ng-container>
      </ng-container>
    </app-modal>
</ng-template>

<ng-template #cardPrimeTemplate>
  <div class="modalPrime__brand">
    <app-ds-icon
      [icon]="icon.RappiProHorz"
      [size]="128">
    </app-ds-icon>
  </div>
  <div class="modalPrime__container">
    <div class="modalPrime__title">
      <app-ds-typography
        [text]="'MODAL_PRIME.TITLE' | transloco"
        [size]="typographySize.MD"
        [fontFamily]="fontFamily.SemiBold"
        [color]="fontColor.Primary">
      </app-ds-typography>
    </div>
    <app-ds-typography
      [text]="'MODAL_PRIME.SUB_TEXT' | transloco"
      [size]="typographySize.XS"
      [fontFamily]="fontFamily.Regular"
      [color]="fontColor.Secondary">
    </app-ds-typography>
    <ul class="modalPrime__benefits-list">
      <li 
        *ngFor="let item of [1,2,3,4]" 
        class="modalPrime__benefit-item">
        <div class="modalPrime__benefit-content">
          <app-ds-icon
            [icon]="icon.Check"
            [size]="24"
            [color]="iconColor.Special">
          </app-ds-icon>
          <app-ds-typography
            [text]="'MODAL_PRIME.BENEFIT_' + item | transloco"
            [size]="typographySize.XS"
            [fontFamily]="fontFamily.Regular"
            [color]="fontColor.Secondary">
          </app-ds-typography>
        </div>
      </li>
    </ul>
    <app-ds-typography
      [text]="'MODAL_PRIME.FOOTER_TEXT' | transloco"
      [size]="typographySize.XS"
      [fontFamily]="fontFamily.SemiBold"
      [color]="fontColor.Primary">
    </app-ds-typography>
  </div>
</ng-template>

<ng-template #cardPrimeFooter>
  <div class="modalPrime__buttons-container">
    <button
      *ngIf="!hasUserInfo"
      class="modalPrime__button" 
      (click)="forceUserLogin()">
        {{'MODAL_PRIME.LOG_IN' | transloco }}
    </button>
    <button 
      class="modalPrime__button modalPrime__button--pro"
      [ngClass]="{'modalPrime__button--full': hasUserInfo}" 
      (click)="deepLinkPro()">
        {{'MODAL_PRIME.WANT_TO_BE_PRO' | transloco }}
    </button>
  </div>
</ng-template>